import { MouseEvent, RefObject, useMemo } from 'react';

import { Box, Card, Divider, Heading } from '@chakra-ui/react';

import { Link } from '~/components/link';

import { getTableOfContentsItems } from '../utils/get-table-of-contents-items';

export function LegalTableOfContents({
  markdownText,
  documentContentContainerRef,
}: {
  markdownText: string;
  documentContentContainerRef: RefObject<HTMLDivElement>;
}) {
  const tableOfContentsItems = useMemo(() => getTableOfContentsItems(markdownText), [markdownText]);
  const hasTableOfContentsItems = Boolean(tableOfContentsItems.length);

  function handleClick(event: MouseEvent<HTMLAnchorElement>, headerText: string) {
    event.preventDefault();

    const headerElements = Array.from(documentContentContainerRef.current?.querySelectorAll('h2') ?? []);

    const foundHeaderElement = headerElements.find(
      (headerElement) => headerElement.innerText.toLowerCase() === headerText.toLowerCase()
    );

    if (foundHeaderElement) {
      foundHeaderElement.scrollIntoView();
    }
  }

  return hasTableOfContentsItems ? (
    <Box
      position={{
        md: 'sticky',
      }}
      top={{
        md: '80px',
      }}
    >
      <Card
        as='nav'
        padding='32px'
        maxHeight={{
          md: 'calc(100vh - 104px)',
        }}
        overflow={{
          md: 'auto',
        }}
      >
        <Heading as='h2' size='h3'>
          Index
        </Heading>
        <Divider marginBottom='8px' marginTop='24px' />

        {tableOfContentsItems.map((tableOfContentsItem) => (
          <Box key={tableOfContentsItem} marginTop='16px'>
            <Link
              _visited={{ color: '' }}
              href='#'
              onClick={(event) => {
                handleClick(event, tableOfContentsItem);
              }}
            >
              {tableOfContentsItem}
            </Link>
          </Box>
        ))}
      </Card>
    </Box>
  ) : null;
}
